import React from "react";
import PropTypes from "prop-types";
import List from "share/atoms/ListView";
import { Wrapper } from "./styles";
import { sidebarData } from "./helpers";
import SidebarItems from "share/molecules/sidebar/sidebar-items";
import LeftSection from "./LeftSection";

const SideContentLayout = ({ children }) => (
  <Wrapper>
    <section className="left">
      <LeftSection/>
    </section>
    <section className="right">{children}</section>
  </Wrapper>
);

export default SideContentLayout;

SideContentLayout.propTypes = {
  children: PropTypes.node,
};
